import { render, staticRenderFns } from "./register.vue?vue&type=template&id=0de9f429&"
import script from "@/model/register?vue&type=script&lang=js&"
export * from "@/model/register?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports